import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../theme/color-palette';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';

import {
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Button,
	IconButton,
} from '@material-ui/core';
import { BOGLE_REGULAR, BOGLE_MEDIUM } from '../../constants/constant';

const { BLACK, WHITE, PURPLE, LIGHT_GREY1, WHITE_OPACITY_7 } = colors;

const useStyles = makeStyles(() => ({
	cancelButton: {
		textTransform: 'none ',
		borderRadius: '25px ',
		borderColor: `${LIGHT_GREY1}`,
		color: `${PURPLE} `,
		paddingTop: '6px ',
		marginRight: '8px',
		fontWeight: 600,
	},
	dialogActions: {
		'&.MuiDialogActions-root': {
			padding: '0px 24px 24px',
		},
	},
	deleteDialogTitle: {
		fontSize: '22px',
		padding: '24px 24px 20px 24px',
		fontFamily: BOGLE_MEDIUM,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	deleteDialogContent: {
		color: BLACK,
		fontSize: '16px',
		margin: '0 24px 24px',
		fontFamily: BOGLE_REGULAR,
	},
	deleteButton: {
		fontSize: '14px',
		fontFamily: 'Bogle-Regular',
		fontWeight: 600,
		textTransform: 'none',
		color: WHITE,
		backgroundColor: PURPLE,
		'&:hover': {
			backgroundColor: `${PURPLE} `,
		},
	},
	dialogContainer: {
		'& .MuiDialog-paper': {
			maxWidth: '507px',
			width: '100%',
		},
		'& .MuiBackdrop-root': {
			backgroundColor: WHITE_OPACITY_7,
		},
		'& .MuiPaper-elevation24': {
			boxShadow: '0px 5px 10px 3px #00000026, 0px -1px 4px 0px #0000001A',
		},
	},
}));

const WarningDialog = (props) => {
	const { open, handleClose, handleDelete, hierarchy } = props;
	const classes = useStyles();
	const heading = hierarchy?.isDefault
		? 'Delete the default hierarchy?'
		: 'Delete the hierarchy?';

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			className={classes.dialogContainer}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description">
			<DialogTitle
				disableTypography
				className={classes.deleteDialogTitle}
				id="alert-dialog-title">
				{heading}
				<IconButton onClick={handleClose}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			{hierarchy?.isDefault && (
				<DialogContent style={{ padding: 0 }}>
					<DialogContentText
						className={classes.deleteDialogContent}
						id="alert-dialog-description">
						This will reset your default to{' '}
						<Box
							component="span"
							sx={{ fontFamily: `${BOGLE_MEDIUM} !important` }}>
							{'All Departments and Categories'}
						</Box>
						.
					</DialogContentText>
				</DialogContent>
			)}

			<DialogActions className={classes.dialogActions}>
				<Button
					onClick={handleClose}
					variant="outlined"
					className={classes.cancelButton}>
					Cancel
				</Button>
				<Button
					data-test-id="delete-hierarchy-btn"
					variant="contained"
					onClick={() => handleDelete(hierarchy)}
					className={classes.deleteButton}>
					Delete
				</Button>
			</DialogActions>
		</Dialog>
	);
};

WarningDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
	handleDelete: PropTypes.func,
	isDefault: PropTypes.bool,
	hierarchy: PropTypes.object,
};

export default WarningDialog;
